import React, {useMemo, useState} from 'react';
import {SwitchBasic} from "../../switch/SwitchBasic";
import InputSingle from "../../input/InputSingle";
import {deleteFiled, updateFiled} from "../../../api/field/FieldService";
import {handleActiveToast} from "../../sonner/ToastBasic";
import CustomSelectBox from "../../select/CustomSelectBox";
import draggable from "../../../resources/icon/draggable.png";
import FieldFormatDisplay from "./FieldFormatDisplay";

/**
 * `필드 `데이트 `날짜
 * */

function FieldSelect({each, options, dragHandleProps}) {
    const [modify, setModify] =useState(false);
    const [data, setData] =useState(each);
    const update =()=>{
        setModify(true)
    }
    async function save(){
        const response = await updateFiled(data);
        if (response.status===200) {
            setModify(false)
            handleActiveToast({description:"",message:"수정되었습니다.", labelListener:()=>{}})
        }else if(response.response.status===401){
            handleActiveToast({description:"",message:"로그인 하세요.", labelListener:()=>{}})
        }else if(response.response.status===403){
            handleActiveToast({description:"",message:"권한이 없습니다.", labelListener:()=>{}})
        }
    }

    async function deleteItem(){
        if(window.confirm("삭제 하시겠습니까")) {
            const response = await deleteFiled(data.id);
            if (response.status === 200) {
                setModify(false)
                handleActiveToast({
                    description: "", message: "수정되었습니다.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 401) {
                handleActiveToast({
                    description: "", message: "로그인 하세요.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 403) {
                handleActiveToast({
                    description: "", message: "권한이 없습니다.", labelListener: () => {
                    }
                })
            }
        }
    }
    function cancel (){
        setModify(false)
    }

    const groupName = useMemo(() => {
        const matched = options?.find((option) => option.id === parseInt(each.entity, 10));
        return matched?.name ?? "";
    }, [options, each.entity]);

    return (
        <>
            <th className="fieldset-th relative">
                {modify ? (
                    <InputSingle target={'title'}  data={{ data: data, setData: setData }} required={true} className={'field-add'}/>
                ):(<span className={"input-label"}>{each.title}</span>)}

                <img
                    src={draggable}
                    className="draggable-icon"
                    {...dragHandleProps}
                />
            </th>
            <td colSpan={3} className="fieldset-td">
                {modify && options && options.length > 0 ? (
                    <CustomSelectBox
                        target={"entity"}
                        options={options}
                        required={each.isRequired}
                        value={each.entity}
                        readOnly={false}
                        setter={setData}
                    />
                ) : (
                    <FieldFormatDisplay type="SELECT" groupName={groupName} />
                )}
                    <div className="inline-block relative">
                        {modify ? (
                            <SwitchBasic
                                onCheckedChange={(checked) => {
                                    setData((prev) => ({
                                        ...prev,
                                        isRequired: checked,
                                    }));
                                }}
                                className={"absolute top-[-15px] left-[258px]"} defaultChecked={each.isRequired}/>
                        ):(<></>)}
                    </div>


                {modify ? (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-cancel-important" onClick={cancel}>취소</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-save-important " onClick={save}>저장</button>
                    </>
                ) : (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-delete-important" onClick={deleteItem}>삭제</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px]" onClick={update}>수정</button>
                    </>
                )}
            </td>
        </>
    );
}

export default FieldSelect;